function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 12C4.39687 12 2.88984 11.3766 1.75781 10.2422C0.623437 9.11016 0 7.60313 0 6C0 4.39687 0.623437 2.88984 1.75781 1.75781C2.89219 0.625781 4.39687 0 6 0C7.60313 0 9.11016 0.623437 10.2422 1.75781C11.3766 2.89219 12 4.39687 12 6C12 7.60313 11.3766 9.11016 10.2422 10.2422C9.10781 11.3742 7.60313 12 6 12ZM6 0.970313C3.225 0.970313 0.970313 3.225 0.970313 6C0.970313 8.775 3.225 11.0297 6 11.0297C8.775 11.0297 11.0297 8.775 11.0297 6C11.0297 3.225 8.775 0.970313 6 0.970313Z",
  fill: "#9CA0AA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65469 8.13985C7.53047 8.13985 7.40625 8.09298 7.3125 7.99688L5.65782 6.34219C5.56641 6.25079 5.51485 6.12891 5.51485 6.00001V2.69063C5.51485 2.42344 5.73282 2.20547 6 2.20547C6.26719 2.20547 6.48516 2.42344 6.48516 2.69063V5.79844L7.99688 7.31016C8.18672 7.50001 8.18672 7.80704 7.99688 7.99454C7.90313 8.09298 7.77891 8.13985 7.65469 8.13985Z",
  fill: "#9CA0AA"
});

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.f540f105.svg";
export { ForwardRef as ReactComponent };